import PropTypes from 'prop-types';
import styled from '@emotion/styled/macro';
import { alignmentValues, offsetValues, colSet } from './flexbox_styles';
import { edgeSizes } from '../../styles/theme';
import edgeStyle from '../../utils/edgeStyle';

const BaseStyledCol = styled('div')`
  box-sizing: border-box;
  flex: 0 0 auto;
  flex-basis: 100%;
  max-width: 100%;
`;

export const FlexRow = styled('div')`
  ${(props) => props.align && alignmentValues[props.align]};
  box-sizing: border-box;
  display: flex;
  flex: 0 1 auto;
  flex-direction: row;
  flex-wrap: wrap;
  ${(props) => props.pad && edgeStyle('padding', props.pad, edgeSizes)}
  ${(props) => props.margin && edgeStyle('margin', props.margin, edgeSizes)}
`;

export const Grid = styled('div')`
  box-sizing: border-box;
  margin-left: auto;
  margin-right: auto;
  ${(props) => props.pad && edgeStyle('padding', props.pad, edgeSizes)}
  ${(props) => props.margin && edgeStyle('margin', props.margin, edgeSizes)}
`;

export const BaseCol = styled(BaseStyledCol)`
  ${(props) => props.defaultOffset && offsetValues[props.defaultOffset]};
  ${(props) => props.default && colSet[props.default]};
  ${(props) => props.pad && edgeStyle('padding', props.pad, edgeSizes)}
  ${(props) => props.margin && edgeStyle('margin', props.margin, edgeSizes)}

  @media only screen and (min-width: 576px) {
    ${(props) => props.smOffset && offsetValues[props.smOffset]};
    ${(props) => props.sm && colSet[props.sm]};
  }

  @media only screen and (min-width: 768px) {
    ${(props) => props.mdOffset && offsetValues[props.mdOffset]};
    ${(props) => props.md && colSet[props.md]};
  }

  @media only screen and (min-width: 992px) {
    ${(props) => props.lgOffset && offsetValues[props.lgOffset]};
    ${(props) => props.lg && colSet[props.lg]};
  }

  @media only screen and (min-width: 1200px) {
    ${(props) => props.xlOffset && offsetValues[props.xlOffset]};
    ${(props) => props.xl && colSet[props.xl]};
  }
`;

export const FlexBaseCol = styled(BaseStyledCol)`
  flex: 1;
  ${(props) => props.textAlign && `text-align: ${props.textAlign}`}
  ${(props) => props.pad && edgeStyle('padding', props.pad, edgeSizes)}
  ${(props) => props.margin && edgeStyle('margin', props.margin, edgeSizes)}
`;

const childPropTypes = {
  children: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.element),
  ]).isRequired,
};

const buildCols = (components, colNumbers) => {
  if (!Array.isArray(components)) return <BaseCol {...colNumbers}>{components}</BaseCol>;

  return components.map((child, index) => (
     
    <BaseCol key={index} {...colNumbers}>
      {child}
    </BaseCol>
  ));
};

const buildRow = (components, colNumbers) => {
  return <FlexRow>{buildCols(components, colNumbers)}</FlexRow>;
};

export const RowWithFlexCols = (props) => {
  const { children } = props;

  const content = children.length
    ? children.map((child, index) => (
         
        <FlexBaseCol key={index}>{child}</FlexBaseCol>
      ))
    : children;

  return <FlexRow>{content}</FlexRow>;
};
RowWithFlexCols.propTypes = childPropTypes;

export const Row4Cols = (props) => buildRow(props.children, { sm: 12, md: 6, lg: 3 });

export const Row3Cols = (props) => buildRow(props.children, { md: 12, lg: 4 });

export const Row2Cols = (props) => buildRow(props.children, { md: 12, lg: 6 });
